import React from "react";
import _ from "lodash";

import { connect } from "react-redux";
import { Platform } from "react-native";
import { withTranslation } from "react-i18next";
import AuthorizedScreen from "../../components/base/AuthorizedScreen";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../redux/screens/talkchinese/PracticeResultRedux";
import { Actions as PracticeActions } from "../../redux/screens/talkchinese/PracticeRedux";
import { NavigationService } from "../../navigation";
import LoadingIndicator from "../../components/ui/LoadingIndicator";
import UIDs from "../../UIDs";
import ResultViews from "../homework/resultViews";
import * as Helper from "../../utils/Helper";

const uid = UIDs.screens.talkchinese.practiceresult;

let t;
class PracticeResultScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: this._handleLoadScreenViewAsyncDone, error: this._handleAsyncActionError },
            [ActionTypes.UPDATE_UNIT_RESULT_ASYNC]: { done: this._handleUpdateUnitResultAsyncDone, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);
        t = props.t;

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        let { unitId, practiceRole, result } = this.props;
        this.props.loadScreenViewAsync({ unitId, practiceRole }, result);
    }

    refreshScreen() {
        let { planId, unitId, practiceRole, result } = this.props;
        this.props.loadScreenViewAsync({ planId, unitId, practiceRole }, result);
    }

    renderScreen() {
        const { data, result } = this.props.localState;

        if (!this.isActionDone(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)) return <LoadingIndicator />;

        const ResultView = ResultViews[data.unitType];

        //type:1-talkchinese
        return <ResultView {...this.props} data={data} result={result} onReportResult={this._handleReportResult} goToRanking={this._gotoRanking} />;
    }

    _gotoRanking = () => {
        const { unitId, practiceRole } = this.props;
        NavigationService.navigateToPage(this, UIDs.screens.talkchinese.ranking, { unitId, practiceRole });
    };

    _handleReportResult = unitResult => {
        //no need to report result to server when reviewing
        if (this.props.mode === 3) {
            let needReport = false;
            let { unitId, practiceRole } = this.props;
            if (unitResult.answer) unitResult.answer = Helper.convertAnswerToJson(unitResult.answer);
            this.props.reportResult({ ...unitResult, unitId, practiceRole }, needReport);
            this.props.reviewUnitAsync({ ...unitResult, unitId, practiceRole });

            return;
        }

        if (unitResult.answer) unitResult.answer = Helper.convertAnswerToJson(unitResult.answer);

        let { unitId, practiceRole } = this.props;
        unitResult = JSON.stringify({ ...unitResult, unitId, practiceRole });
        this.props.updateUnitResultAsync(unitResult);
    };

    _handleLoadScreenViewAsyncDone = () => {
        // const { data } = this.props.localState;
        // const { vipEnabled } = data;
        // if (!vipEnabled) {
        //     NavigationService.navigateToPage(this, UIDs.screens.me.member);
        // }
    };

    _handleUpdateUnitResultAsyncDone = action => {
        const { canUpgrade, currentBookName, nextBookName, nextBookId } = action.data;
        if (canUpgrade) {
            NavigationService.navigateToPage(this, UIDs.screens.talkchinese.complete, { canUpgrade, current: currentBookName, next: nextBookName, nextId: nextBookId });
        }
    };

    _handleAsyncActionError = action => {
        this.displayError(action.error);
    };
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: (vo, result) => dispatch(Actions.loadScreenViewAsync(vo, result)),
        updateUnitResultAsync: unitResult => dispatch(Actions.updateUnitResultAsync(unitResult)),
        reportResult: (result, needReport) => dispatch(PracticeActions.reportResult(result, needReport)),
        reviewUnitAsync: vo => dispatch(PracticeActions.reviewUnitAsync(vo)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(PracticeResultScreen));
